mutation InvoiceSigningUrgentUpdate($input: InvoiceSigningUrgentUpdateInput!) {
  invoiceSigningUrgentUpdate(input: $input) {
    clientMutationId
         _newUrgentLevel
  }
}
